import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import adminOnboardingActions from 'redux/actions/adminOnboardingActions'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.ADMIN_ONBOARDING_INVITE_CONFIRM

const AdminOnboardingInviteConfirm = props => (<Confirm
	btOne={localize('admin_onboarding_invite_teachers_confirm_btn_one_2')}
	btTwo={localize('admin_onboarding_invite_teachers_confirm_btn_two')}
	alertTitle={localize('admin_onboarding_invite_teachers_confirm_title')}
	alertMessage={''}
	actionButtonType={0}
	actionOne={() => props.actions.inviteConfirmed(CONFIRM_TYPE)}
	actionTwo={() => props.actions.cancelInviteConfirm(CONFIRM_TYPE)}
	centeredTitle={true}
	closeAction={() => props.actions.cancelInviteConfirm(CONFIRM_TYPE)}
/>)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		inviteConfirmed: adminOnboardingActions.inviteConfirmed,
		cancelInviteConfirm: adminOnboardingActions.cancelInviteConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(AdminOnboardingInviteConfirm)
